export default __webpack_public_path__ + "static/media/web_mobile.72091269.png";